import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import SharedSidebar from "../shared/SharedSidebar";
import TaiorMain from "./TaiorMain";

const SIDEBAR_WIDTH = "250px";

const DashboardTailorCombined = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const location = useLocation();
  const isDashboardRoute = location.pathname === "/dashboard";

  return (
    <Box minH="100vh">
      {/* Desktop Sidebar */}
      <Box
        display={{ base: "none", md: "block" }}
        position="fixed"
        top={0}
        left={0}
        w={SIDEBAR_WIDTH}
        h="100vh"
        zIndex={1000}
      >
        <SharedSidebar variant="desktop" role="master" />
      </Box>

      {/* Mobile Sidebar */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="xs">
        <DrawerOverlay />
        <DrawerContent p={0} overflow="hidden">
          <Box w="250px" h="100vh" overflowY="auto" bg="white">
            <SharedSidebar onNavigate={onClose} variant="mobile" role="master" />
          </Box>
        </DrawerContent>
      </Drawer>

      {/* Main Content */}
      <TaiorMain
        isDashboardRoute={isDashboardRoute}
        SIDEBAR_WIDTH={SIDEBAR_WIDTH}
        onSidebarOpen={onOpen} // ✅ Pass onOpen properly
      />
    </Box>
  );
};

export default DashboardTailorCombined;
